<template>

  <div class="main-content">
    <NavBar  v-bind:displayLogo="true" v-bind:displayUser="false"></NavBar>
    <div class="container-login justify-content-center">
      <div class="card-login">
        <h5 class="card-header-login">Cambiar contraseña</h5>
        <div class="card-body-login"  id="cuenta">

          <div class="form-group has-feedback formio-component formio-component-email formio-component-email" >
            <label class="col-form-label">Nueva Contraseña</label>
            <div ref="element">
              <input id="newpassword-input" value="" lang="en" class="form-control" type="password" name="newpassword-input">
            </div>
          </div>
          <button id="change-pass" class="btn btn-primary">Submit</button>
        </div>
      </div>
      <br />

    </div>

  </div>
</template>

<script>
import { Form } from "vue-formio";
import { Formio } from 'formiojs';
import { config } from '@/formio/config'
import NavBar from '@component-basic/NavBar.vue'

export default {
  metaInfo: {
    title: "Cambiar contraseña"
  },
  components: {
    formio: Form,
    NavBar
  },
  data() {
    var token = this.$route.params.token

    let formioRequest = new Formio(config.forms.resetpassword);
    formioRequest.
    loadSubmissions({ params: { "data.token": this.$route.params.token }})
        .then(submissions =>
        {
          if(submissions[0] == undefined)
            this.$router.push({ name: "home" });

          console.log(submissions[0].data.email)
          this.email = submissions[0].data.email;
          this.id = submissions[0]._id;
        });


    return {
      // miCuentaForm: miCuentaForm,
      token : token,
      email : "",
      id : "",
      changeData :true,
      rows:[],
    };
  },
  mounted ()
  {
    var that = this;
    $(document).on("click", "#change-pass", function ()
    {
      if($("#newpassword-input").val().trim() != "")
        that.changePass();
    });
  },
  methods: {
    changePass()
    {
      let element = document.querySelectorAll("#newpassword-input")[0];

      let formioRequest = new Formio(config.forms.usuario);
      formioRequest.
      loadSubmissions({ params: { "data.email": this.email }})
          .then(submissions =>
          {
            var newData = submissions[0].data;
            newData["password"] = $("#newpassword-input").val().trim();

            var formio = new Formio(config.forms.usuario);
            formio.saveSubmission({
              _id: submissions[0]._id,
              data: newData
            }).then((updated) =>{
              var formio = new Formio( config.forms.resetpassword +'/submission/'+ this.id);
              formio.deleteSubmission();
              Swal.fire({
                icon: 'success',
                title: 'Se ha cambiado su clave con éxito',
              })
              setTimeout(() => {
                this.$router.push({ name: "home" });
              }, 3000)


            });

          });

    }

  }
};
</script>
<style>
.formio-select-autocomplete-input,
.choices__list--single{
  display: none;
}

.choices[data-type*=select-one] .choices__input {
  display: block;
  width: 100%;
  margin: 0;
  background-color: #f9f9f9;
  padding: 12px;
  border: 1px solid #ddd;
}
div.choices.form-group.formio-choices > div.form-control.ui.fluid.selection.dropdown{
  border: 1px solid transparent;
  background-color: transparent;
  height: calc(1.9695rem + 2px);
  padding: 0px 0px;
}

.choices[data-type*=select-one] .choices__input,
.form-control{
  padding: 0px 12px;
}

.choices__item--selectable{
  background:#fff;
  color:#000;
}

#cuenta > div > div > div > .formio-component-email, #cuenta > div > div > div > .formio-component-nombres, #cuenta > div > div > div > .formio-component-apellidos {
  display:none;
}
#cuenta > div > div > div >  .formio-component-email2{
  display:block !important;
}
</style>
